"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancel = exports.select = exports.setSelection = exports.moveSelection = exports.getInventory = exports.getActionList = exports.drawAll = exports.close = exports.open = exports.isOpen = exports.get = void 0;
var assert_sidecar_1 = require("../../../lib/assert-sidecar");
var mathUtils_sidecar_1 = require("../../../lib/mathUtils-sidecar");
var rogueItems_sidecar_1 = require("../items/rogueItems-sidecar");
var rogueItemsData_1 = require("../items/rogueItemsData");
var rogueMonofont_sidecar_1 = require("../monofont/rogueMonofont-sidecar");
var rogueMonsters_sidecar_1 = require("../monsters/rogueMonsters-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueStats_sidecar_1 = require("./rogueStats-sidecar");
// export interface IRogueInventoryItem {
//   name: string
//   amount: number
//   letter: string
// }
var alphabet = 'abcdefghijklmnopqrstuvwxyz';
var _obj = null;
var get = function () {
    if (!_obj) {
        _obj = {
            // items: [],
            isOpen: false,
            highlightedItemIdx: 0,
            highlightedActionIdx: 0,
            selectedItem: null,
        };
        // Seed with some fake items
        for (var i = 0; i < 7; i++) {
            // _obj.items.push({
            //   name: `Item ${i}`,
            //   amount: 1,
            //   letter: alphabet[i],
            // })
        }
    }
    return _obj;
};
exports.get = get;
var isOpen = function () {
    return (0, exports.get)().isOpen;
};
exports.isOpen = isOpen;
var open = function () {
    var obj = (0, exports.get)();
    obj.isOpen = true;
    obj.selectedItem = null;
};
exports.open = open;
var close = function () {
    var obj = (0, exports.get)();
    obj.isOpen = false;
    obj.selectedItem = null;
};
exports.close = close;
var drawAll = function () {
    var obj = (0, exports.get)();
    if (!obj.isOpen) {
        return;
    }
    var x = 1;
    var y = 1;
    (0, exports.moveSelection)(0, 0); // Reset wrap
    rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'Inventory $' + rogueStats_sidecar_1.rogueStats.getStats().gold);
    y++;
    var inventory = (0, exports.getInventory)();
    if (inventory.length === 0) {
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'You are carrying nothing.');
        return;
    }
    if (obj.selectedItem) {
        var actions = (0, exports.getActionList)(obj.selectedItem);
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, rogueItems_sidecar_1.rogueItems.getItemName(obj.selectedItem));
        y++;
        var _loop_1 = function (i) {
            var action = actions[i];
            y++;
            var isHighlighted = i === obj.highlightedActionIdx;
            // let letter = alphabet[i]
            rogueMonofont_sidecar_1.rogueMonofont.write(x, y, (isHighlighted ? '>' : ' ') + action.letter + ':' + action.name, rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.dark, function () {
                (0, exports.setSelection)(i);
                (0, exports.select)();
            }, function () {
                (0, exports.setSelection)(i);
            }, action.letter);
        };
        for (var i = 0; i < actions.length; i++) {
            _loop_1(i);
        }
    }
    else {
        var _loop_2 = function (i) {
            var item = inventory[i];
            y++;
            var isHighlighted = i === obj.highlightedItemIdx;
            var letter = alphabet[i];
            rogueMonofont_sidecar_1.rogueMonofont.write(x, y, (isHighlighted ? '>' : ' ') +
                letter +
                ':' +
                rogueItems_sidecar_1.rogueItems.getItemName(item), rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.dark, function () {
                (0, exports.setSelection)(i);
                (0, exports.select)();
            }, function () {
                (0, exports.setSelection)(i);
            }, letter);
        };
        for (var i = 0; i < inventory.length; i++) {
            _loop_2(i);
        }
    }
};
exports.drawAll = drawAll;
var getActionList = function (item) {
    var actions = [
        {
            name: 'Drop',
            letter: 'd',
            action: function () {
                var p = rogueMonsters_sidecar_1.rogueMonsters.getPlayer();
                assert_sidecar_1.assert.notNil(p);
                rogueItems_sidecar_1.rogueItems.drop(p, item);
            },
        },
        {
            name: 'Cancel',
            letter: 'c',
            action: function () {
                var obj = (0, exports.get)();
                obj.selectedItem = null;
            },
        },
    ];
    if (item.data.group === rogueItemsData_1.ERogueItemGroup.potion) {
        actions.unshift({
            name: 'Quaff / Drink',
            letter: 'q',
            action: function () {
                var p = rogueMonsters_sidecar_1.rogueMonsters.getPlayer();
                assert_sidecar_1.assert.notNil(p);
                rogueMonsters_sidecar_1.rogueMonsters.removeFromInventory(p, item);
                rogueItems_sidecar_1.rogueItems.kill(item);
            },
        });
    }
    if (item.data.group === rogueItemsData_1.ERogueItemGroup.scroll) {
        actions.unshift({
            name: 'Read / Cast',
            letter: 'r',
            action: function () {
                var p = rogueMonsters_sidecar_1.rogueMonsters.getPlayer();
                assert_sidecar_1.assert.notNil(p);
                rogueMonsters_sidecar_1.rogueMonsters.removeFromInventory(p, item);
                rogueItems_sidecar_1.rogueItems.kill(item);
            },
        });
    }
    return actions;
};
exports.getActionList = getActionList;
var getInventory = function () {
    var p = rogueMonsters_sidecar_1.rogueMonsters.getPlayer();
    if (!p) {
        return [];
    }
    var inventory = p.inventory;
    return inventory;
};
exports.getInventory = getInventory;
var moveSelection = function (oy, ox) {
    var obj = (0, exports.get)();
    if (obj.selectedItem) {
        (0, exports.setSelection)(obj.highlightedActionIdx + oy);
    }
    else {
        (0, exports.setSelection)(obj.highlightedItemIdx + oy);
    }
};
exports.moveSelection = moveSelection;
var setSelection = function (selIdx) {
    var obj = (0, exports.get)();
    if (obj.selectedItem) {
        var actions = (0, exports.getActionList)(obj.selectedItem);
        obj.highlightedActionIdx = selIdx;
        obj.highlightedActionIdx = mathUtils_sidecar_1.mathUtils.betterMod(obj.highlightedActionIdx, actions.length || 1);
    }
    else {
        obj.highlightedItemIdx = selIdx;
        // Wrap
        var inventory = (0, exports.getInventory)();
        obj.highlightedItemIdx = mathUtils_sidecar_1.mathUtils.betterMod(obj.highlightedItemIdx, inventory.length || 1);
    }
};
exports.setSelection = setSelection;
var select = function () {
    var obj = (0, exports.get)();
    var inventory = (0, exports.getInventory)();
    if (inventory.length === 0) {
        (0, exports.close)();
        return;
    }
    if (!obj.selectedItem) {
        var item = inventory[obj.highlightedItemIdx];
        obj.selectedItem = item;
    }
    else {
        // What are we doing with this item?
        var actions = (0, exports.getActionList)(obj.selectedItem);
        var action = actions[obj.highlightedActionIdx];
        if (action) {
            action.action();
            obj.selectedItem = null;
            (0, exports.close)();
        }
    }
    // if (item.action) {
    //   item.action()
    // }
    // if (item.command) {
    //   rogueInput.setNextInputCommand(item.command)
    // }
    // close()
};
exports.select = select;
var cancel = function () {
    (0, exports.close)();
};
exports.cancel = cancel;
